/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "../style/PlansCard.css";
import price1 from "../assets/img/price1.png";
import price2 from "../assets/img/price2.png";
import price3 from "../assets/img/price3.png";

export const Pricing = () => {
  return (
    <section className="pricing" id="pricing">
      <body>
        <div class="bg">
          {/* <h1>Pricing</h1> */}
          {/* <img src={bg2} /> */}
        </div>
        <div class="nft">
          <div class="main">
            <img
              class="tokenImage"
              // src="https://images.unsplash.com/photo-1621075160523-b936ad96132a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
              src={price1}
              alt="NFT"
            />
            <h2 className="h2">Basic</h2>
            <p class="description">
              1-3 pages with unique design and a complimentary hero banner
            </p>
            <div class="tokenInfo">
              <div class="price">
                <ins>◘</ins>
                <p>INR 10,000</p>
              </div>
              <div class="duration">
                <ins>◷</ins>
                <p>1 Month</p>
              </div>
            </div>
            <a href="/src/components/Contact.js">
              <button className="quote">View Plan</button>
            </a>
            <hr />
          </div>
        </div>

        <div class="nft">
          <div class="main">
            <img
              class="tokenImage"
              // src="https://images.unsplash.com/photo-1621075160523-b936ad96132a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
              src={price2}
              alt="NFT"
            />
            <h2 className="h2">Standard</h2>
            <p class="description">
              3-7 custom pages, mockup with custom graphic & content writing
            </p>
            <div class="tokenInfo">
              <div class="price">
                <ins>◘</ins>
                <p>INR 20,000</p>
              </div>
              <div class="duration">
                <ins>◷</ins>
                <p>1 Month</p>
              </div>
            </div>
            <a href="/src/components/Contact.js">
              <button className="quote">View Plan</button>
            </a>
            <hr />
          </div>
        </div>

        <div class="nft">
          <div class="main">
            <img
              class="tokenImage"
              // src="https://images.unsplash.com/photo-1621075160523-b936ad96132a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
              src={price3}
              alt="NFT"
            />
            <h2 className="h2">Premium</h2>
            <p class="description">
              15 custom pages, mockup, custom graphic, content & payment gateway
            </p>
            <div class="tokenInfo">
              <div class="price">
                <ins>◘</ins>
                <p>INR 40,000</p>
              </div>
              <div class="duration">
                <ins>◷</ins>
                <p>2 Months</p>
              </div>
            </div>
            <a href="/src/components/Contact.js">
              <button className="quote">View Plan</button>
            </a>
            <hr />
          </div>
        </div>
      </body>
    </section>
  );
};
